import React from 'react';

export const NotFound = () => <h1>not found</h1>;

